__turbopack_context__.v({
  "carousel": "styles-module__6rsk3G__carousel",
  "carouselAction": "styles-module__6rsk3G__carouselAction",
  "carouselActionContainer": "styles-module__6rsk3G__carouselActionContainer",
  "carouselActionContainerLeft": "styles-module__6rsk3G__carouselActionContainerLeft",
  "carouselActionContainerRight": "styles-module__6rsk3G__carouselActionContainerRight",
  "carouselActionLeft": "styles-module__6rsk3G__carouselActionLeft",
  "carouselActionRight": "styles-module__6rsk3G__carouselActionRight",
  "carouselContainer": "styles-module__6rsk3G__carouselContainer",
  "carouselMultiSlide": "styles-module__6rsk3G__carouselMultiSlide",
  "dot": "styles-module__6rsk3G__dot",
  "dotActive": "styles-module__6rsk3G__dotActive",
  "dotsContainer": "styles-module__6rsk3G__dotsContainer",
  "emptyCarouselSpace": "styles-module__6rsk3G__emptyCarouselSpace",
  "mediaContainer": "styles-module__6rsk3G__mediaContainer",
});
